
import { Component, Vue } from "vue-property-decorator";
import { namespace } from "vuex-class";
import dayjs from "dayjs";
import _ from "lodash-es";
const dashboard = namespace("dashboard");
@Component({})
export default class Notice extends Vue {
  @dashboard.Action getNoticeList;
  @dashboard.Action readNotice;
  dayjs = dayjs;
  created() {
    this.init();
  }
  noticeListData: any = [];
  pageNum: number = 1;
  total: number = 0;
  init() {
    this.getNoticeList({
      pageSize: 20,
      pageNum: this.pageNum
    }).then(data => {
      this.total = data.data.total;
      this.noticeListData.push(
        ...this.$safeValue(data, "data.list", []).map(item => {
          item.siteJson = item.site ? JSON.parse(item.site) : {};
          return item;
        })
      );
    });
  }
  mounted() {
    const dom = this.$refs.pageNotice as any;
    dom.addEventListener(
      "scroll",
      _.debounce(() => {
        const clientHeight = dom.clientHeight;
        const scrollTop = dom.scrollTop;
        const scrollHeight = dom.scrollHeight;
        console.log(clientHeight, scrollTop, scrollHeight);
        if (clientHeight + scrollTop + 20 >= scrollHeight) {
          this.handleLoadMore();
        }
      }, 100)
    );
  }
  handleRead(row) {
    if (row.readStatus) {
      if (row.site) {
        let site = "";
        try {
          site = JSON.parse(row.site).pc;
        } catch (e) {
          return;
        }
        if (site) {
          let { href } = this.$router.resolve({
            path: site
          });
          window.open(href, "_blank");
        }
      }
      return;
    }
    this.readNotice({
      innerMsgCode: row.innerMsgCode
    }).then(() => {
      row.readStatus = 1;
      if (row.site) {
        let site = "";
        try {
          site = JSON.parse(row.site).pc;
        } catch (e) {
          return;
        }
        if (site) {
          let { href } = this.$router.resolve({
            path: site
          });
          window.open(href, "_blank");
        }
      }
    });
  }
  handleLoadMore() {
    this.pageNum++;
    this.init();
  }
  handleReadAll() {
    this.readNotice({
      innerMsgCode: null
    }).then(() => {
      this.noticeListData.forEach(item => {
        item.readStatus = 1;
      });
    });
  }
}
